module.exports = __webpack_public_path__ + "static/bubble-emoji-9e6252459ae9a89fd63cf31f706f64eb.png";